import { createSlice } from '@reduxjs/toolkit';

interface GenericSettingsStore {
    language?: string;
}

const initialState: GenericSettingsStore = {
    language: undefined,
};

const genericSettingsSlice = createSlice({
    name: 'genericSettings',
    initialState,
    reducers: {
        setSettingsLanguage(state, action) {
            state.language = action.payload;
        },
    },
});

export const { setSettingsLanguage } = genericSettingsSlice.actions;

export default genericSettingsSlice.reducer;
